import _ from "lodash"

import type { SortDirection } from "./sortDirection"

export type SortState<TRow> = {
  column: string | null;
  data: TRow[];
  direction: SortDirection | null;
};

export type SortAction<TRow> =
  | { type: 'CHANGE_SORT'; column: string }
  | { type: 'CLEAR_FILTERS'; data: TRow[] };

export function sortReducer<TRow>(state: SortState<TRow>, action: SortAction<TRow>): SortState<TRow> {
    switch (action.type) {
      case 'CHANGE_SORT':
        if (state.column === action.column) {
          return {
            ...state,
            data: state.data.slice().reverse(),
            direction:
              state.direction === 'ascending' ? 'descending' : 'ascending',
          }
        }
        return {
          column: action.column,
          data: _.sortBy(state.data, [action.column]),
          direction: 'ascending',
        }
        case 'CLEAR_FILTERS':
            return {
                ...state,
                data: action.data
            }
      default:
        throw new Error()
    }
  }
